import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import search from './searchTable';

import modal from './modal';

import routingaxios from './routingAxios';

import displaymenu from './displayMenu';

import getuser from './getUser';

import getformvalues from './getFormValues';

import conditionform from './conditionForm';

import auth from "./auth"

import axiosQueue from "./axiosQueue"

import divers from "./diversFunctions";
import chat from '../components/chat/store';
import { installRightsInspection } from '../components/engine/rightsInspection/state';



export default new Vuex.Store({
    plugins: [installRightsInspection],
    modules: {
        search: search,
        modal: modal,
        routaxios: routingaxios,
        displaymenu: displaymenu,
        getuser: getuser,
        getformvalues: getformvalues,
        conditionform: conditionform,
        auth: auth,
        axiosqueue: axiosQueue,
        diversFunc: divers,
        chat
    }
});
